var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1",
    "data-name": "Groupe 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.996,
    height: 21,
    viewBox: "0 0 15.996 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M15.29,4.359,11.336.617A2.247,2.247,0,0,0,9.785,0H2.256A2.258,2.258,0,0,0,0,2.256V18.744A2.258,2.258,0,0,0,2.256,21H13.74A2.258,2.258,0,0,0,16,18.744V6A2.265,2.265,0,0,0,15.29,4.359ZM14.1,4.922H11.033a.205.205,0,0,1-.205-.205V1.831ZM13.74,19.77H2.256A1.027,1.027,0,0,1,1.23,18.744V2.256A1.027,1.027,0,0,1,2.256,1.23H9.6V4.717a1.437,1.437,0,0,0,1.436,1.436h3.732V18.744A1.027,1.027,0,0,1,13.74,19.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M12.387,8.2H3.363a.615.615,0,0,0,0,1.23h9.023a.615.615,0,1,0,0-1.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M12.387,11.484H3.363a.615.615,0,1,0,0,1.23h9.023a.615.615,0,1,0,0-1.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M6.346,14.766H3.363a.615.615,0,0,0,0,1.231H6.346a.615.615,0,0,0,0-1.231Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.15b20b5dfa22226be12edcc90c6c277c.svg";
export { ForwardRef as ReactComponent };